






















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ProjectModel } from "../models";

const pStore = namespace("projects");
const snackStore = namespace("snackbar");

@Component
export default class ProjectInfo extends Vue {
  @pStore.Getter lastFiveBuy!: ProjectModel[];

  @pStore.Action fetchBuyProjects!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  headers = [
    { text: "Projectnummer", value: "id", sortable: false },
    { text: "Omschrijving", value: "description", sortable: false },
  ];

  pagination = {
    descending: true,
  };

  mounted(): void {
    this.fetchBuyProjects().catch(() => {
      this.defaultError();
    });
  }
}
